<template lang="html">
  <section class="app-menu text-center">
    <b-list-group class="list-group">
      <b-list-group-item @click="setComponent(table_name) && setCurrentElement(null)"
                         v-for="(num_rows, table_name) in getTables" :key="table_name"
                         class="text-uppercase d-flex justify-content-between align-items-center"
                         :class="{activeClass : getComponent === table_name}">{{ table_name.split('_').join(' ') }}
        <b-badge class="dark-color" pill>{{num_rows}}</b-badge>
      </b-list-group-item>
    </b-list-group>
  </section>
</template>

<script lang="js">
import {mapActions, mapGetters} from 'vuex';
export default {
  name: 'Menu',
  props: [],
  mounted () {},
  created() {
    this.readNumRowsTables();
  },
  data () {
    return {}
  },
  methods: {
    ...mapActions([
      'setComponent',
      'setCurrentElement',
      'readNumRowsTables'
    ])
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getTables'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-menu {}
  .dark-color{
    background-color: var(--dark-color);
  }
  .activeClass{
    background-color: var(--dark-color);
    color: var(--white-color) !important;
  }
  .list-group > .list-group-item:hover {
    background-color: var(--dark-color);
    color: var(--white-color);
    cursor: pointer;
    border: 1px solid var(--white-color);
  }
  .list-group > .list-group-item:hover > .dark-color, .activeClass > .dark-color{
    background-color: var(--white-color);
    color: var(--dark-color);
  }
  .list-group-item {
    font-weight: bold;
    color: var(--dark-color);
    border-color: var(--dark-color);
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Menu.vue